import imageFilter from './image-filter';
import tileTap from './tile-tap';
import kApp from './k-app';
import aceIt from './ace-it';

export default {
  imageFilter,
  tileTap,
  kApp,
  aceIt,
} as {[key: string]: string};



// WEBPACK FOOTER //
// ./src/components/project-documentations/documentations/index.ts